import type ChargebeeAddon from './ChargebeeAddon'
import { Pricing, PricingType } from './Pricing'

const COUNTRIES = ['us', 'mx', 'br', 'co', 'gb']
const APP_COUNTRIES = [...COUNTRIES, 'ar']
const AREA_A = [
  'es',
  'pt',
  'it',
  'bg',
  'hr',
  'cy',
  'cz',
  'ee',
  'gr',
  'hu',
  'lv',
  'lt',
  'mt',
  'pl',
  'ro',
  'sk',
  'ie',
  'si',
  'tr',
]

const AREA_B = ['at', 'be', 'dk', 'fi', 'fr', 'de', 'lu', 'nl', 'se', 'ch']

export const getRegion = (country: string, isStarterPlan = false) => {
  if (
    APP_COUNTRIES.includes(country) ||
    (isStarterPlan && country === 'de') ||
    (isStarterPlan && country === 'us')
  ) {
    return country
  }

  if (AREA_A.includes(country)) {
    return 'area_a'
  }

  if (AREA_B.includes(country)) {
    return 'area_b'
  }

  return 'world'
}

function getPlanPricing(addons: ChargebeeAddon[], country: string) {
  const areaAddons = addons.filter((addon) => {
    return addon.isCompatible(country, getRegion(country))
  })

  // Group addons by period unit (month or year)
  const pricingAddon = areaAddons?.reduce(
    (acc, addon) => {
      if (addon.isPerSeat()) acc[addon.periodUnit].perSeat = addon
      if (addon.isFee()) acc[addon.periodUnit].fee = addon
      if (addon.isTiered()) acc[addon.periodUnit].tiered = addon
      return acc
    },
    { month: {}, year: {} } as PricingType
  )

  if (!Object.keys(pricingAddon.month).length || !Object.keys(pricingAddon.year).length) return null

  return new Pricing(pricingAddon.month, pricingAddon.year)
}

export default getPlanPricing
